import {t} from '@lingui/core/macro';

import {PlugState} from 'entities/user';

export const getIncidentsEmptyState = (plugState: PlugState): string | true =>
    plugState === 'notFound' ? t`Ничего не найдено` : true;
